/**
 * These are switch cases for consumeCsvContent on the backend
 * We also use it to get their required columns before send to backend
 */
export enum DevelopmentContractUploadType {
  PlanBased = "bidContractPlanBased",
  Itemized = "bidContractItemizedCosts",
}
